import { oc } from '@orpc/contract';
import { impactPreviewInputSchema, impactPreviewOutputSchema } from '../schemas/policies.schemas.js';
/**
 * Before → after over every open estimate, priced with each estimate's own template version and
 * inspection (PP AC08). Nothing is written; the administrator reads the table and then publishes.
 */
export const previewPolicyImpactContract = oc
    .route({
    method: 'POST',
    path: '/policies/impact-preview',
    tags: ['Policies'],
    summary: 'Show what these equations would do to the open estimates',
})
    .input(impactPreviewInputSchema)
    .output(impactPreviewOutputSchema);
//# sourceMappingURL=preview-policy-impact.contract.js.map